import { validateConfig } from './config'
import { setLoadTimeout } from './actions'
import viewportListener from './viewportListener'
import clickListener from './clickListener'
import scrollListener from './scrollListener'
import videoListener from './videoListener'
import kalturaListener from './kalturaListener'

/**
 * @param {Partial<import('./config').TealiumConfig>} [config]
 * @returns {TeardownFunction}
 */
export function setupTealium (config) {
  let {
    customTrackingAttribute,
    untrackedSelectors,
    ddo,
    enableAppendAriaExpanded,
    enableAppendAriaExpandedInversion,
    enableDeviceTracking,
    enableScrollTracking,
    enableVideoControlsTracking,
    enableVTIMTracking,
    env,
    scrollPercentiles,
    utagScriptPathPrefix,
    timeout,
    videoPercentiles,
    viewports,
    kalturaConfig
  } = validateConfig(config)

  if (timeout) setLoadTimeout(timeout)

  /** @type {TeardownFunction[]} */
  let teardownFns = []

  try{
    if (window) {
      window.APP = {}
      window.digitalData = ddo

      teardownFns.push(addTagScript(env, utagScriptPathPrefix))

      if (enableDeviceTracking) {
        teardownFns.push(viewportListener(viewports))
      }

      teardownFns.push(
        clickListener(
          enableVTIMTracking,
          enableDeviceTracking,
          enableAppendAriaExpanded,
          enableAppendAriaExpandedInversion,
          customTrackingAttribute,
          untrackedSelectors
        )
      )

      if (enableScrollTracking) {
        teardownFns.push(scrollListener(scrollPercentiles))
      }

      teardownFns.push(videoListener(videoPercentiles, enableVideoControlsTracking))
      teardownFns.push(kalturaListener(kalturaConfig, enableVTIMTracking))
    } else {
      throw new Error('Window object does not exist')
    }
  } catch (error) {
    console.log('ERROR:', error)
  }

  return () => {
    teardownFns.forEach(teardown => teardown())
  }
}

/**
 *
 * @param {string} environment - Which tracking environment to send activities to: 'prod', 'notprod'
 * @param {string} utagScriptPathPrefix - Source folder for the utag script: 'mcoe', 'main'
 * @returns {TeardownFunction}
 */
const addTagScript = (environment, utagScriptPathPrefix) => {
  let script = document.createElement('script')
  script.src = `https://tags.tiqcdn.com/utag/bofa/${utagScriptPathPrefix}/${environment}/utag.js`
  script.type = 'text/javascript'
  script.async = true
  document.head.appendChild(script)
  window.bactm_envSelector = environment

  return () => {
    script.remove()
  }
}
